package com.arenaproplay.admin.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.arenaproplay.admin.navigation.Routes
import com.arenaproplay.admin.ui.utils.encodeQueryValue
import com.arenaproplay.admin.ui.utils.urlParam

/**
 * Legacy /api-stats route — redirects to /system?tab=api.
 *
 * Content has fully moved to the «API» tab of SystemPage (R8).
 *
 * URL param mapping:
 *   ?period=… → forwarded as ?period=…
 */
@Page("/api-stats")
@Composable
fun ApiStatsPage() {
    val ctx = rememberPageContext()
    LaunchedEffect(Unit) {
        val params = buildString {
            val period = urlParam("period")?.ifBlank { null }
            if (period != null) append("&period=${encodeQueryValue(period)}")
        }
        ctx.router.navigateTo("${Routes.SYSTEM}?tab=api$params")
    }
}
